import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const formatErr = (d) => {
  if (!d) return "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map(x => x?.msg || "").filter(Boolean).join(" · ");
  return String(d);
};

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await register(email, password, name);
      if (r.purchases_attached > 0) {
        toast.success(`Welcome — ${r.purchases_attached} previous purchase(s) attached to your account`);
      } else {
        toast.success("Account created");
      }
      navigate("/dashboard");
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6 py-14 bg-[#FAF4F5]">
      <div className="w-full max-w-md bg-white border border-[#E8DCDD] rounded-sm p-8">
        <div className="text-[10px] tracking-[0.28em] uppercase text-[#8C4A57] mb-2">Create your student account</div>
        <h1 className="font-serif text-3xl text-[#2D2628] mb-1">Register</h1>
        <p className="text-sm text-[#6B5E62] mb-6">Use the same email you used at checkout — any prior purchases will attach automatically.</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-[10px] tracking-[0.2em] uppercase text-[#6B5E62]">Your name</label>
            <input type="text" value={name} onChange={e => setName(e.target.value)}
              data-testid="register-name" placeholder="Jane Doe"
              className="w-full border border-[#E8DCDD] rounded-sm px-3 py-2 text-sm mt-1"/>
          </div>
          <div>
            <label className="text-[10px] tracking-[0.2em] uppercase text-[#6B5E62]">Email</label>
            <input type="email" required value={email} onChange={e => setEmail(e.target.value)}
              data-testid="register-email"
              className="w-full border border-[#E8DCDD] rounded-sm px-3 py-2 text-sm mt-1"/>
          </div>
          <div>
            <label className="text-[10px] tracking-[0.2em] uppercase text-[#6B5E62]">Password (8+ chars, letters + numbers)</label>
            <input type="password" required value={password} onChange={e => setPassword(e.target.value)}
              data-testid="register-password" minLength={8}
              className="w-full border border-[#E8DCDD] rounded-sm px-3 py-2 text-sm mt-1"/>
          </div>
          <button type="submit" disabled={busy} data-testid="register-submit"
            className="w-full bg-[#8C4A57] text-white text-[12px] tracking-[0.14em] uppercase font-semibold py-3 rounded-sm hover:bg-[#6f3945] transition disabled:opacity-60">
            {busy ? "Creating…" : "Create account"}
          </button>
        </form>
        <p className="text-xs text-[#6B5E62] text-center mt-6">
          Already have an account? <Link to="/login" className="text-[#8C4A57] font-semibold">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
